(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.ConfirmDialogController = (function(superClass) {
    extend(ConfirmDialogController, superClass);

    function ConfirmDialogController(scope, transitions, modalInstance) {
      var base, base1, base2, base3;
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.save = bind(this.save, this);
      ConfirmDialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      if ((base = this.scope).title == null) {
        base.title = 'Confirm';
      }
      if ((base1 = this.scope).body == null) {
        base1.body = 'Are you sure you want to do this thing?';
      }
      if ((base2 = this.scope).noText == null) {
        base2.noText = 'No';
      }
      if ((base3 = this.scope).yesText == null) {
        base3.yesText = 'Yes';
      }
      this.scope.fullpage = false;
    }

    ConfirmDialogController.prototype.save = function() {
      return this.modalInstance.close();
    };

    return ConfirmDialogController;

  })(DialogController);

}).call(this);
